import UserPartnerAccountEditForm from './UserPartnerAccountEditForm';

export default UserPartnerAccountEditForm;
